// Copyright (c) Ensho Health, 2022 to present
import api from '../api';

const PREFIX = 'notification';

export const ACTION_TYPES = {
  SET_ERROR: `${PREFIX}-SET_ERROR`,
  SET_WARNING: `${PREFIX}-SET_WARNING`,
  SET_SUCCESS: `${PREFIX}-SET_SUCCESS`
};

export const NOTIFICATION_TYPES = {
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success'
};

/**
 * Set the notification reducer and send the error to the backend if requested
 * Args:
 *  notification is an object shaoped like:
 * {
 *  type: type of the notification, one of the above, required
 *  display: message for the user to display in the toast. If not provided, nothing
 *     will be displayed to the user
 *  serverMessage: message for the server, if omitted nothing will be sent to the back
 *    end
 *  info: additional information we want to provide about this notification,
 *    mainly for the server
 * }
 */
export function setNotification(notification) {
  return async (dispatch) => {
    try {
      if (!notification.hasOwnProperty('type')) {
        throw new Error(
          'notification needs at least a type and a display message ',
          notification
        );
      }

      if (!Object.values(NOTIFICATION_TYPES).includes(notification.type)) {
        throw new Error('unknwon notification type ', notification.type);
      }

      if (notification.hasOwnProperty('display')) {
        let dispatchType = '';
        if (notification.type === NOTIFICATION_TYPES.WARNING) {
          dispatchType = ACTION_TYPES.SET_WARNING;
        } else if (notification.type === NOTIFICATION_TYPES.SUCCESS) {
          dispatchType = ACTION_TYPES.SET_SUCCESS;
        } else if (notification.type === NOTIFICATION_TYPES.ERROR) {
          dispatchType = ACTION_TYPES.SET_ERROR;
        } else {
          throw new Error('unknwon notification type ', notification.type);
        }
        dispatch({
          type: dispatchType,
          payload: notification.display
        });
      }

      // sending the notification to the server message if requested
      if (notification.hasOwnProperty('serverMessage')) {
        const serverObject = {
          message: notification.serverMessage,
          type: notification.type,
          info: notification.info
        };
        await api.notification.sendNotification(serverObject);
      }
    } catch (error) {
      // if the error notification failed there is nothing much we can do,
      // logging the failure here
      console.error(error.message);
    }
  };
}
